import React, { useState, useEffect } from "react";
import OwlCarousel from "react-owl-carousel2";
import { CustomContainer, Row, Col } from "../../atoms/DependencyHelper";
import {
  componentResize,
  getTagName,
  getPromotionLabel,
  getPromotionVariant,
  componentCheckSize,
  getFinalPrice,
  getAmountOffValue,
  getRegularPrice,
} from "../../../utils/helperServices";
import styles from "./cardsCarousel.module.scss";
import ProductCards from "../ProductCards/ProductCards";
import labels from "../../../config/labels";
import CarouselButton from "../../atoms/buttons/carouselButton/CarouselButton";
import PropTypes from "prop-types";
import * as Analytics from "../../../services/analyticsUtag";

export default function CardsCarousel({
  cards = [],
  collectionName = "",
  alignment,
  tabName = "",
}) {
  const isMobile = componentCheckSize() < 768;
  const isTablet = componentCheckSize() <= 1024;
  const [previousNavClass, setPreviousNavClass] = useState("");
  const [nextNavClass, setNextNavClass] = useState("");
  const goToProducts = () => {
    // Router.replace('/');
  };
  let productCarousel;

  const next = () => {
    if (productCarousel) {
      productCarousel.next(600);
    }
  };
  const prev = () => {
    if (productCarousel) {
      productCarousel.prev(600);
    }
  };

  const carouselOptions = {
    nav: true,
    autoplay: false,
    animateIn: "animate__fadeIn",
    autoWidth: true,
    lazyLoad: true,
    navContainerClass: "owl--nav--container",
    dotsClass: "owl--dots pt-0",
    dotClass: "owl--dot",
    slideBy: 1,
    responsive: {
      0: {
        dots: true,
        margin: 0,
      },
      1024: {
        dots: false,
        margin: 8,
      },
    },
  };

  const events = {
    onInitialized: function (event) {
      toggleCarouselNavDisabled(event);
    },
    onTranslated: function (event) {
      toggleCarouselNavDisabled(event);
    },
  };

  function toggleCarouselNavDisabled(event) {
    const index = event.item.index;
    const minimum = 0;
    const maximum = event.item.count;

    let previousNav = index <= minimum ? "disabled" : "";
    let nextNav =
      index +
        carouselOptions.responsive[event.relatedTarget._breakpoint].slideBy >=
      maximum
        ? "disabled"
        : "";

    setPreviousNavClass(previousNav);
    setNextNavClass(nextNav);
  }

  const handleBuyNow = (product) => {
    const analyticsViewData = Analytics.getUtagData([
      "page_name",
      "page_channel",
      "page_master_tab",
      "page_site_section_lvl_1",
      "page_site_section_lvl_2",
      "page_site_section_lvl_3",
    ]);
    const analyticsData = {
      link_type: "o",
      link_name: `${analyticsViewData.page_name}: product select: ${
        product.name
      }${tabName ? ": " + tabName : ""}`,
      sales_product_category: [product?.categories?.[0]?.name],
      sales_product_id: [product?.name],
      sales_product_price: [getFinalPrice(product)],
      sales_product_quantity: [1],
    };
    if (product?.badges_label) {
      analyticsData.sales_promo_name = [product?.badges_label];
    }
    Analytics.link({
      ...analyticsViewData,
      ...analyticsData,
    });
  };

  return (
    <>
      <CustomContainer
        className={`d-flex ${
          !isTablet && alignment == "CENTER"
            ? "justify-content-center"
            : "justify-content-left"
        }`}
      >
        {cards.length > 0 && isTablet && (
          <CustomContainer className={styles["content-container"]}>
            <OwlCarousel
              ref={(c) => (productCarousel = c)}
              options={carouselOptions}
              events={events}
            >
              {cards.map((item, index) => (
                <CustomContainer
                  className={`d-flex ${styles["content-item"]}`}
                  key={index}
                >
                  {index === 0 ? (
                    <ProductCards
                      className={styles["mobile-card-view"]}
                      buttonClassName={styles["custom-button-style"]}
                      priceRequired
                      itemName={item?.name}
                      itemImage={item?.image.url}
                      imageLabel={item?.image.label}
                      maximumPrice={
                        item?.price_range?.maximum_price?.regular_price?.value
                      }
                      minimumPrice={
                        getAmountOffValue(item) === "0"
                          ? getFinalPrice(item) !== "0"
                            ? getFinalPrice(item)
                            : getRegularPrice(item)
                          : getRegularPrice(item)
                      }
                      dealProductPrice={
                        item?.price_range?.maximum_price?.regular_price?.value
                      }
                      buttonLabelReq={labels.lbl_buy_now}
                      isMobile={isMobile}
                      promotionLabel={item?.promotion_tag != null ? getPromotionLabel(item) : ''}
                      promotionVariant={getPromotionVariant(item)}
                      promotionLabelColor={
                        getPromotionLabel(item) === item?.promotion_tag_label
                          ? item.promotion_tag_swatch
                          : item?.badges_swatch
                          ? item.badges_swatch
                          : null
                      }
                      cardWidth="15.625rem"
                      imgWidth="11.25rem"
                      imgHeight="11.25rem"
                      sku={item?.sku}
                      item={item}
                      buyNowReq
                      id={item?.sku}
                      data-cms-title={
                        collectionName
                          ? `${collectionName}: ${item.name}`
                          : item.name
                      }
                      ctaHandler={handleBuyNow}
                    />
                  ) : (
                    <ProductCards
                      className={styles["mobile-card-view"]}
                      buttonClassName={styles["custom-button-style"]}
                      priceRequired
                      itemName={item?.name}
                      itemImage={item?.image.url}
                      imageLabel={item?.image.label}
                      maximumPrice={
                        item?.price_range?.maximum_price?.regular_price?.value
                      }
                      minimumPrice={
                        getAmountOffValue(item) === "0"
                          ? getFinalPrice(item) !== "0"
                            ? getFinalPrice(item)
                            : getRegularPrice(item)
                          : getRegularPrice(item)
                      }
                      buttonLabelReq={labels.lbl_buy_now}
                      isMobile={isMobile}
                      promotionLabel={item?.promotion_tag != null ? getPromotionLabel(item) : ''}
                      promotionVariant={getPromotionVariant(item)}
                      promotionLabelColor={
                        getPromotionLabel(item) === item?.promotion_tag_label
                          ? item.promotion_tag_swatch
                          : item?.badges_swatch
                          ? item.badges_swatch
                          : null
                      }
                      cardWidth="15.625rem"
                      imgWidth="11.25rem"
                      imgHeight="11.25rem"
                      sku={item?.sku}
                      item={item}
                      buyNowReq
                      id={item?.sku}
                      data-cms-title={
                        collectionName
                          ? `${collectionName}: ${item.name}`
                          : item.name
                      }
                      ctaHandler={handleBuyNow}
                    />
                  )}
                </CustomContainer>
              ))}
            </OwlCarousel>
            {!isMobile && (
              <div className={`custom-owl--nav ${styles["owl--nav"]}`}>
                <CarouselButton
                  prev
                  handleClick={prev}
                  className={previousNavClass}
                  id="CardsCarousel_arrowBackBtn"
                />
                <CarouselButton
                  next
                  handleClick={next}
                  className={nextNavClass}
                  id="CardsCarousel_arrowNextBtn"
                />
              </div>
            )}
          </CustomContainer>
        )}
        {cards.length > 0 && !isTablet && (
          <CustomContainer className={` d-flex `}>
            {cards.map((item, index) => (
              <CustomContainer
                className={`d-flex ${styles["content-item"]} ${
                  alignment == "CENTER"
                    ? "justify-content-center"
                    : "justify-content-left"
                } mr-xs ml-sm-xs`}
                key={item.name + index}
              >
                {index === 0 ? (
                  <ProductCards
                    className={styles["mobile-card-view"]}
                    buttonClassName={styles["custom-button-style"]}
                    priceRequired
                    itemName={item?.name}
                    itemImage={item?.image?.url}
                    imageLabel={item?.image?.label}
                    maximumPrice={
                      item?.price_range?.maximum_price?.regular_price?.value
                    }
                    minimumPrice={
                      getAmountOffValue(item) === "0"
                        ? getFinalPrice(item) !== "0"
                          ? getFinalPrice(item)
                          : getRegularPrice(item)
                        : getRegularPrice(item)
                    }
                    buttonLabelReq={labels.lbl_buy_now}
                    isMobile={isMobile}
                    promotionLabel={item?.promotion_tag != null ? getPromotionLabel(item) : ''}
                    promotionVariant={getPromotionVariant(item)}
                    promotionLabelColor={
                      getPromotionLabel(item) === item.promotion_tag_label
                        ? item.promotion_tag_swatch
                        : item.badges_swatch
                    }
                    cardWidth="15.625rem"
                    imgWidth="11.25rem"
                    imgHeight="11.25rem"
                    sku={item.sku}
                    item={item}
                    buyNowReq
                    id={item.sku}
                    data-cms-title={
                      collectionName
                        ? `${collectionName}: ${item.name}`
                        : item.name
                    }
                    ctaHandler={handleBuyNow}
                  />
                ) : (
                  <ProductCards
                    className={styles["mobile-card-view"]}
                    buttonClassName={styles["custom-button-style"]}
                    priceRequired
                    itemName={item?.name}
                    itemImage={item?.image?.url}
                    imageLabel={item?.image?.label}
                    maximumPrice={
                      item?.price_range?.maximum_price?.regular_price?.value
                    }
                    minimumPrice={
                      getAmountOffValue(item) === "0"
                        ? getFinalPrice(item) !== "0"
                          ? getFinalPrice(item)
                          : getRegularPrice(item)
                        : getRegularPrice(item)
                    }
                    buttonLabelReq={labels.lbl_buy_now}
                    isMobile={isMobile === true}
                    promotionLabel={item?.promotion_tag != null ? getPromotionLabel(item) : ''}
                    promotionVariant={getPromotionVariant(item)}
                    promotionLabelColor={
                      getPromotionLabel(item) === item?.promotion_tag_label
                        ? item.promotion_tag_swatch
                        : item?.badges_swatch
                        ? item.badges_swatch
                        : null
                    }
                    cardWidth="15.625rem"
                    imgWidth="11.25rem"
                    imgHeight="11.25rem"
                    sku={item?.sku}
                    item={item}
                    buyNowReq
                    id={item?.sku}
                    data-cms-title={
                      collectionName
                        ? `${collectionName}: ${item.name}`
                        : item.name
                    }
                    ctaHandler={handleBuyNow}
                  />
                )}
              </CustomContainer>
            ))}
          </CustomContainer>
        )}
      </CustomContainer>
    </>
  );
}

CardsCarousel.propTypes = {
  cards: PropTypes.array,
  collectionName: PropTypes.string,
};
